import React from 'react'

const Spinner = () => {
  return (
    <div>
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner

//its config is from css loader generator
//its in index.css
//for loading 
